// START IMPORTS
import { useSubscriptionAccessConfigContext } from '@ltvco/refresh-lib/ctx';
import { Box } from '@ltvco/refresh-lib/theme';
import { Header } from '@ltvco/refresh-lib/v2';
import { useFeatureIsOn, useFeatureValue } from '@ltvco/refresh-lib/vendors';
import { useEffect } from 'react';
// END IMPORTS

// START INTERFACES_AND_TYPES
type HeaderParentProps = {
  handleSearchSuccess: any;
  changeSingleReportVariation: (variation: boolean) => void;
  changeOwnerSearchVariation: (variation: boolean) => void;
  changeIsInAstrologyStandaloneVariation: (variation: boolean) => void;
  changeInternationalLanguageTest: (variation: boolean) => void;
  changeInternationalVinTest: (variation: boolean) => void;
  changeListV2Variation: (variation: boolean) => void;
  changeCourtCasesVariation: (variation: boolean) => void;
  changeOar1946Variation: (variation: string) => void;
  changeOar1980Variation: (variation: boolean) => void;
};
// END INTERFACES_AND_TYPES

export const HeaderParent = ({
  handleSearchSuccess,
  changeSingleReportVariation,
  changeIsInAstrologyStandaloneVariation,
  changeInternationalLanguageTest,
  changeInternationalVinTest,
  changeListV2Variation,
  changeCourtCasesVariation,
  changeOar1946Variation,
  changeOar1980Variation,
}: HeaderParentProps) => {
  const isInAstrologyStandaloneVariation = useFeatureIsOn('oar-1164');
  const isInListV2Variation = useFeatureIsOn('prop-2834');
  const isInCourtCasesVariation = useFeatureIsOn('court-case-search');
  const oar1946Variation = useFeatureValue<string>('OAR-1946', '');
  const oar1980Variation = useFeatureIsOn('OAR-1980');

  const {
    singleReportVariation,
    internationalLanguageVariation,
    vinVariation,
  } = useSubscriptionAccessConfigContext();
  // END HOOKS_AND_QUERIES

  // START EFFECTS
  useEffect(() => {
    changeSingleReportVariation(singleReportVariation);
  }, [singleReportVariation]);

  useEffect(() => {
    changeIsInAstrologyStandaloneVariation(isInAstrologyStandaloneVariation);
  }, [isInAstrologyStandaloneVariation]);

  useEffect(() => {
    changeInternationalLanguageTest(internationalLanguageVariation);
  }, [internationalLanguageVariation]);

  useEffect(() => {
    changeInternationalVinTest(vinVariation);
  }, [vinVariation]);

  useEffect(() => {
    changeListV2Variation(isInListV2Variation);
  }, [isInListV2Variation]);

  useEffect(() => {
    changeCourtCasesVariation(isInCourtCasesVariation);
  }, [isInCourtCasesVariation]);

  useEffect(() => {
    changeOar1946Variation(oar1946Variation);
  }, [oar1946Variation]);

  useEffect(() => {
    changeOar1980Variation(oar1980Variation);
  }, [oar1980Variation]);

  if (location.pathname.includes('/chatbv')) {
    return null;
  }
  // END EARLY_RETURNS

  // START RENDER
  return (
    <Box>
      <Header onSearchSuccess={handleSearchSuccess} />
    </Box>
  );
  // END RENDER
};
